import Vue from 'vue';
import App from '@/App.vue';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import axios from 'axios';

import { preventTwoFinger, preventDoubleTap } from '@/common/util/control';

// スマホ操作制御
preventTwoFinger();
preventDoubleTap();

Vue.config.productionTip = false;

// const messages = {
//   en: {
//     message: {
//       カード: 'card',
//     },
//   },
//   ja: {
//     message: {
//       カード: 'カード',
//     },
//   },
// };

// const i18n = new VueI18n({
//   locale: 'ja',
//   messages,
// });

const loadQuorizaBaseScript = () => {
  if (!document.getElementById('quoriza-base')) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('data-custom-script', 'itp-tag-repo');
    script.innerHTML = `
      (function (w, d, ns, blid) {
      w['ItpTagRepoObject'] = ns;
      w[ns] = w[ns] || { api_key: blid };
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://rc.quoriza.net/v1/sdk.js';
      var x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    })(window, document, 'ItpTagRepo', 'RBE-qtO0V7OwHuo');
    `;
    document.head.appendChild(script);
  }
};

const loadQuorizaConversionScript = (config) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.setAttribute('data-custom-script', 'hc-tracking');
  script.innerHTML = `
    var hc_access_key = "13101";
    var hc_unique_id = "${config.pay_unique_id}";
    var hc_measure1 = "${config.pay_price}";
    var hc_measure2 = "${config.pay_member_id}";
    var hc_measure3 = "";
    var hc_ec_value = "";
    (function() {
      var hc = document.createElement('script'); 
      hc.type = 'text/javascript'; 
      hc.async = true;
      hc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 't.quoriza.net/tk/conversion.js';
      var ps = document.getElementsByTagName('script')[0]; 
      ps.parentNode.insertBefore(hc, ps);
    })();
  `;
  document.head.appendChild(script);
};

function removeAppendedTag() {
  const canonicalTag = document.querySelector('link[rel="canonical"]');
  if (canonicalTag) {
    canonicalTag.parentNode.removeChild(canonicalTag);
  }

  let script = document.querySelector('script[data-custom-script="hc-tracking"]');
  if (script) {
    script.parentNode.removeChild(script);
  }
  script = document.querySelector('script[data-custom-script="itp-tag-repo"]');
  if (script) {
    script.parentNode.removeChild(script);
  }
}

router.afterEach(async (to) => {
  removeAppendedTag();
  if (to.meta.complete_pay) {
    axios.get('/api/user/pay_result')
      .then((response) => {
        const config = response.data;
        if (config) {
          loadQuorizaConversionScript(config);
          loadQuorizaBaseScript();
        }
      })
      .catch((error) => {
        console.error('APIからのデータ取得に失敗しました', error);
      });
  } else {
    if (to.meta.isTop) {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://oripalette.jp';
      document.head.appendChild(link);
    } else if (to.name === 'PackDetail' && to.query.packId) {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = `https://oripalette.jp/pack-detail?packId=${to.query.packId}`;
      document.head.appendChild(link);
    }
    loadQuorizaBaseScript();
  }
});

new Vue({
  router,
  store,
  vuetify,
  // i18n,
  render: (h) => h(App),
}).$mount('#app');
